import { Card } from "@fanduel/og-fe-library";
import Lock from "@/components/svg/Lock";
import { colorNavyD3 } from "../../../../styles/manualVars";
import Styles from "./EmptyMessage.module.scss";

const EmptyMessage = () => (
  <Card className={Styles.card}>
    <Lock fill={colorNavyD3} />
    <div className={Styles.title}>Odds not available at this time.</div>
    <div className={Styles.microcopy}>Please check back later.</div>
  </Card>
);

export default EmptyMessage;
